/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_AInputs */



/**
* | output |
* | --- |
* | "Event A" |
*
* @param {Event_AInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_a = /** @type {((inputs?: Event_AInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_AInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événement A")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltung A")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento A")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие А")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento A")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件 A")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントA")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना ए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento A")
	return /** @type {LocalizedString} */ ("Event A")
});